import { Line, Vector2 } from "./linearAlgebraModel";
import { normalize, subV } from "./vectorUtils";

export function getLineDir(line: Line): Vector2 {
  const [start, end] = line;
  const diffVector = subV(end, start);
  const dir = normalize(diffVector);
  return dir;
}
